<template>
    <div class="part-placeholder">
        <div class="mt-2 mb-2">
            <a href="#" v-on:click.prevent="goToSearch">Return to Search</a>
        </div>
        <div class="d-flex mb-2">
            <div class="part-header-panel d-flex flex-grow-1 ul-red-panel ul-wide-border-panel">
                <div class="d-flex flex-column align-items-center justify-content-center pl-2 pr-2">
                    <img class="part-image" v-bind:src="partImageSrc()">
                </div>
                <div class="d-flex flex-column justify-content-center flex-grow-1 pl-2 pr-2">
                    <div class="d-flex justify-content-between align-items-baseline">
                        <h1 class="d-flex flex-column part-detail-mfr-header">
                            <span class="placeholder-span"></span>
                            <span class="placeholder-span font-weight-bold"></span>
                        </h1>
                    </div>
                    <div class="part-detail-description">
                        <span class="placeholder-span"></span>
                    </div>
                </div>
            </div>
        </div>
        <div class="tab-content ul-red-panel ul-wide-border-panel ul-light-background mb-3">
            <div>
                <div class="view-preview-panel">
                    <ul class="nav nav-pills flex-row flex-wrap justify-content-around p-2">
                        <li class="nav-item active">
                            <span class="nav-link btn btn-dark placeholder-span active"></span>
                        </li>
                        <li class="nav-item">
                            <span class="nav-link btn btn-dark placeholder-span"></span>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link btn btn-dark placeholder-span"></a>
                        </li>
                    </ul>
                    <div class="d-flex flex-row flex-wrap justify-content-around pl-2 pr-2">
                        <div id="preview-symbol" class="preview-pane active flex-even p-2">
                            <h2 class="frut-55-roman preview-title placeholder-span"></h2>
                            <div class="preview-wrap">
                                <div>
                                    <div class="svg-wrap preview-panel">
                                    </div>
                                </div>
                                <div class="d-flex flex-column justify-content-center ml-5 mr-5 mt-2 mb-2">
                                    <div class="d-flex align-items-center p-2">
                                        <div class="form-control form-control-sm rounded-0 preview-selector"></div>
                                        <i class="ul-html-tooltip placeholder-span"></i>
                                    </div>
                                    <div class="d-flex align-items-center p-2">
                                        <div class="form-control form-control-sm rounded-0 preview-selector"></div>
                                        <i class="ul-html-tooltip placeholder-span"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="preview-footprint" class="preview-pane flex-even p-2">
                            <h2 class="frut-55-roman preview-title placeholder-span"></h2>
                            <div class="preview-wrap">
                                <div>
                                    <div class="svg-wrap preview-panel">
                                    </div>
                                </div>
                                <div class="d-flex flex-column justify-content-center ml-5 mr-5 mt-2 mb-2">
                                    <div class="d-flex align-items-center p-2">
                                        <div class="form-control form-control-sm rounded-0 preview-selector"></div>
                                        <i class="ul-html-tooltip placeholder-span"></i>
                                    </div>
                                    <div class="d-flex align-items-center p-2">
                                        <div class="form-control form-control-sm rounded-0 preview-selector"></div>
                                        <i class="ul-html-tooltip placeholder-span"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="preview-3d-model" class="preview-pane flex-even p-2">
                            <h2 class="frut-55-roman preview-title placeholder-span"></h2>
                            <div class="preview-wrap">
                                <div>
                                    <div class="svg-wrap preview-panel">
                                    </div>
                                </div>
                                <div class="d-flex flex-column justify-content-center ml-5 mr-5 mt-2 mb-2">
                                    <div class="d-flex align-items-center p-2">
                                        <div class="form-control form-control-sm rounded-0 preview-selector"></div>
                                        <i class="ul-html-tooltip placeholder-span"></i>
                                    </div>
                                    <div class="d-flex align-items-center p-2">
                                        <div class="form-control form-control-sm rounded-0 preview-selector"></div>
                                        <i class="ul-html-tooltip placeholder-span"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-column align-items-center justify-content-center mt-2 mb-2">
                    <a class="btn btn-dark" disabled><img style="max-height:24px;" src="../assets/images/placeholders/loading.gif" /></a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PartPanel",
        methods: {
            goToSearch() {
                this.$root.$emit('change_panel', 'search');
            },
            partImageSrc() {
                return require('../assets/images/placeholders/Image-Unavailable.png');
            }
        }
    }
</script>

<style scoped>
    .placeholder-span {
        background: grey;
        border-radius: 20px !important;
        height: 1em;
        width: 1em;
        display: inline-block;
        text-align: center;
    }

    .justify-content-around {
        text-align: center;
    }

    div.part-header-panel span {
        width: 5em;
        height: .5em;
    }

    div.part-detail-description span {
        width: 20em;
        height: 1em;
    }

    .preview-pane h2.placeholder-span {
        width: 10em;
    }

    h1 span.part-detail-mfr-header {
        width: 5em;
        height: .5em;
    }
</style>